import { useEffect, useState } from "react";
import GuideDowntimeCapsules from "./GuideDowntimeCapsules/GuideDowntimeCapsules";
import GuideDowntimeTable from "./GuideDowntimeTable/GuideDowntimeTable";
import { dataQueryStatus } from "utils";
import { Empty, Loading } from "components/ui";
import ErrorView from "components/ui/ErrorView/ErrorView";
import { apiRoute } from "services";
import { getErrorMessage } from "utils/helper";
import { connect, useDispatch } from "react-redux";
import API from "services/lib/api";
import { saveCapsuleClassess } from "store/capsule/actions";

const { IDLE, LOADING, ERROR, DATAMODE, NULLMODE } = dataQueryStatus;
const GuideDowntime = ({saveCapsuleClassess, capsuleClasses }) => {
    const [status, setStatus] = useState(IDLE);
    const [errorMssg, setErrorMssg] = useState();
    const [selectedCapsuleClass, selectCapsuleClass] = useState();

    const dispatch = useDispatch();

    const getCapsuleClasses = async (httpRequest) => {
        try {
            setStatus(LOADING);
            const url = apiRoute?.getCapsuleClasses;
            const res = await API.get(url, { signal: httpRequest?.signal });

            if (res.status === 200) {
                const { data } = res.data;
                await dispatch(saveCapsuleClassess(data));
                data?.length > 0 ? setStatus(DATAMODE) : setStatus(NULLMODE);
            }
        } catch (err) {
            setStatus(ERROR);
            const message = getErrorMessage(err);
            setErrorMssg(message);
        }
    };

    const selectFirstClass = async () => {
        if (capsuleClasses?.length > 0) {
            selectCapsuleClass(capsuleClasses[0]);
            setStatus(DATAMODE);
        } else {
            selectCapsuleClass();
            setStatus(NULLMODE);
        }
    };

    useEffect(() => {
        selectFirstClass();
        // eslint-disable-next-line
    }, [capsuleClasses]);

    const findFirstClass = async (httpRequest) => {
        if (capsuleClasses?.length > 1) {
            await selectFirstClass();
        } else {
            await getCapsuleClasses(httpRequest);
        }
    };

    useEffect(() => {
        let httpRequest = new AbortController();
        findFirstClass(httpRequest);
        return () => {
            httpRequest.abort();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const renderBasedOnStatus = () => {
        switch (status) {
            case IDLE:
                return <Empty text='Please wait...' />;

            case LOADING:
                return <Loading />;

            case ERROR:
                return (
                    <ErrorView
                        message={errorMssg}
                        handleRetry={getCapsuleClasses}
                    />
                );

            case NULLMODE:
                return <Empty text={"No Guide Downtimes Available Yet"} />;

            case DATAMODE:
                return (
                    <>
                        <GuideDowntimeTable
                            selectedCapsuleClass={selectedCapsuleClass}
                        />
                    </>
                );

            default:
                return "";
        }
    };


    return (
        <>
            <div className='padded__layout agentaguides'>
                <GuideDowntimeCapsules
                    {
                    ...{
                        capsuleClasses,
                        selectedCapsuleClass,
                        selectCapsuleClass,
                    }
                    }
                />
                {renderBasedOnStatus()}
            </div>
        </>
    );
};


export default connect(
    (state) => ({
        capsuleClasses: state?.capsule?.capsuleClasses,
    }),
    { saveCapsuleClassess }
)(GuideDowntime);
